<div class="form-control slider-control" [formGroup]="form">
	<label for="slider" [for]="form_control_id" class="label">
		{{ label }}
	</label>
	<div class="control-container" [class.in-focus]="is_focused" [class.is-dirty]="form_control.dirty">
		<label *ngIf="!!prefix" [for]="form_control_id" class="prefix">{{ prefix }}</label>
		<div>
			<div *ngIf="display_value" class="display-value">
				{{ display_value }}
			</div>
			<input
				*ngIf="!display_value"
				id="input"
				class="slider-input"
				[type]="'number'"
				[id]="form_control_id"
				[attr.name]="form_control_name"
				[formControlName]="form_control_name"
				[attr.placeholder]="placeholder"
				[min]="min"
				[step]="step"
				[max]="max"
				(focus)="onFocus()"
				(blur)="onBlur()"
				(keyup.enter)="roundValue()"
				pattern="[0-9.]*"
				inputmode="numeric"
			/>
		</div>
		<label *ngIf="!!suffix" [for]="form_control_id" class="suffix">{{ suffix }}</label>
		<a class="button small-button minor-button">OK</a>
		<mat-slider
			#slider
			id="slider"
			[value]="form_control.value"
			[min]="min"
			[step]="step"
			[max]="max"
			[invert]="invert"
			[disabled]="!!(disabled || loading)"
			[color]="'primary'"
			(slidestart)="onFocus()"
			(slideend)="is_focused = false; setValue(slider.value)"
			(pointerup)="is_focused = false; setValue(slider.value)"
			(input)="onSliderInput($event)"
		></mat-slider>
	</div>
	<span *ngIf="info !== null" class="info" [class.highlighted]="highlighted_info">{{ info }}</span>
</div>
